import * as api from "../api/postAPI";
import * as types from "../constants/postConstants";

export const createPostAction = (formData) => async (dispatch) => {
  try {
    const {
      error = null,
      data = null,
      info = null,
      isInappropriate = false,
      confirmationToken = null,
    } = await api.createPost(formData);

    if (error) {
      throw new Error(error);
    }

    if (isInappropriate) {
      dispatchCreatePostFail(
        dispatch,
        types.CREATE_POST_FAIL_INAPPROPRIATE,
        null
      );
      return { success: false, error: "Post contains inappropriate content" };
    } else if (confirmationToken) {
      dispatchCreatePostFail(
        dispatch,
        types.CREATE_POST_FAIL_DETECT_CATEGORY,
        confirmationToken
      );
      return { success: false, error: "Post requires category confirmation" };
    } else if (info) {
      dispatchCreatePostFail(
        dispatch,
        types.CREATE_POST_FAIL_CATEGORY_MISMATCH,
        info
      );
      return { success: false, error: "Post category mismatch" };
    } else {
      dispatchCreatePostSuccess(dispatch, types.CREATE_POST_SUCCESS, data);
      return { success: true };
    }
  } catch (error) {
    dispatchCreatePostFail(dispatch, types.CREATE_POST_FAIL, error.message);
    return { success: false, error: error.message };
  }
};

const dispatchCreatePostSuccess = (dispatch, type, payload) => {
  dispatch({
    type,
    payload,
    meta: {
      requiresAuth: true,
    },
  });
};

const dispatchCreatePostFail = (dispatch, type, payload) => {
  dispatch({
    type,
    payload,
    meta: {
      requiresAuth: true,
    },
  });
};

export const clearCreatePostFail = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_CREATE_POST_FAIL,
    meta: {
      requiresAuth: true,
    },
  });
};

export const confirmPostAction = (confirmationToken) => async (dispatch) => {
  try {
    const { error, data } = await api.confirmPost(confirmationToken);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.CONFIRM_POST_SUCCESS,
      payload: data,
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.CONFIRM_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const rejectPostAction = (confirmationToken) => async (dispatch) => {
  try {
    const { error, data } = await api.rejectPost(confirmationToken);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.REJECT_POST_SUCCESS,
      payload: data,
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.REJECT_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const getPostAction = (id) => async (dispatch) => {
  try {
    console.log('[getPostAction] Fetching post with ID:', id);
    const { error, data } = await api.getPost(id);

    if (error) {
      console.error('[getPostAction] Error from API:', error);
      throw new Error(error);
    }

    console.log('[getPostAction] Post fetched successfully:', data?._id);
    dispatch({
      type: types.GET_POST_SUCCESS,
      payload: data,
      // Removed requiresAuth meta since post viewing is now public
    });
  } catch (error) {
    console.error('[getPostAction] Exception caught:', error);
    dispatch({
      type: types.GET_POST_FAIL,
      payload: error.message,
      // Removed requiresAuth meta since post viewing is now public
    });
  }
};

export const clearPostAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_POST,
    meta: {
      requiresAuth: true,
    },
  });
};

export const clearPostsAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_POSTS,
    meta: {
      requiresAuth: true,
    },
  });
};

export const getPostsAction = (limit, skip) => async (dispatch) => {
  try {
    const { error, data } = await api.getPosts(limit, skip);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_POSTS_SUCCESS,
      payload: {
        page: skip / limit + 1,
        posts: data.formattedPosts,
        totalPosts: data.totalPosts,
      },
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_POSTS_FAIL,
      payload: error,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const getOwnPostAction = (id) => async (dispatch) => {
  try {
    const { error, data } = await api.getPost(id);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_OWN_POST_SUCCESS,
      payload: data,
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_OWN_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const getComPostsAction =
  (communityId, limit, skip) => async (dispatch) => {
    try {
      const { error, data } = await api.getComPosts(communityId, limit, skip);

      if (error) {
        throw new Error(error);
      }

      dispatch({
        type: types.GET_COMMUNITY_POSTS_SUCCESS,
        payload: {
          page: skip / limit + 1,
          posts: data.formattedPosts,
          totalCommunityPosts: data.totalCommunityPosts,
        },
        meta: {
          requiresAuth: true,
        },
      });
    } catch (error) {
      dispatch({
        type: types.GET_COMMUNITY_POSTS_FAIL,
        payload: error.message,
        meta: {
          requiresAuth: true,
        },
      });
    }
  };

export const clearCommunityPostsAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_COMMUNITY_POSTS,
    meta: {
      requiresAuth: true,
    },
  });
};

export const getFollowingUsersPostsAction =
  (communityId) => async (dispatch) => {
    try {
      const { error, data } = await api.getFollowingUsersPosts(communityId);

      if (error) {
        throw new Error(error);
      }

      dispatch({
        type: types.GET_FOLLOWING_USERS_POSTS_SUCCESS,
        payload: data,
        meta: {
          requiresAuth: true,
        },
      });
    } catch (error) {
      dispatch({
        type: types.GET_FOLLOWING_USERS_POSTS_FAIL,
        payload: error.message,
        meta: {
          requiresAuth: true,
        },
      });
    }
  };

export const updatePostAction = (id, postData) => async (dispatch) => {
  try {
    const { error, data } = await api.updatePost(id, postData);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.UPDATE_POST_SUCCESS,
      payload: data,
      meta: {
        requiresAuth: true,
      },
    });    
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.UPDATE_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });   
    return { success: false, error: error.message };
  }
};

export const deletePostAction = (id) => async (dispatch) => {
  try {
    const { error } = await api.deletePost(id);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.DELETE_POST_SUCCESS,
      payload: id,
      meta: {
        requiresAuth: true,
      },
    });    
    return { success: true };
  } catch (error) {
    dispatch({
      type: types.DELETE_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });   
    return { success: false, error: error.message };
  }
};

export const likePostAction = (id) => async (dispatch) => {
  try {
    const { error, data } = await api.likePost(id);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.LIKE_POST_SUCCESS,
      payload: data,
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.LIKE_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const unlikePostAction = (id) => async (dispatch) => {
  try {
    const { error, data } = await api.unlikePost(id);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.UNLIKE_POST_SUCCESS,
      payload: data,
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.UNLIKE_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const addCommentAction = (postId, newComment) => async (dispatch) => {
  try {
    const { error } = await api.addComment(postId, newComment);

    if (error === "inappropriateContent") {
      dispatch({
        type: types.ADD_COMMENT_FAIL_INAPPROPRIATE,
        meta: {
          requiresAuth: true,
        },
      });
      return;
    }

    throw new Error(error);
  } catch (error) {
    dispatch({
      type: types.ADD_COMMENT_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const clearCommentFailAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_COMMENT_FAIL,
    meta: {
      requiresAuth: true,
    },
  });
};

export const savePostAction = (id) => async (dispatch) => {
  try {
    const { error, data } = await api.savePost(id);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.SAVE_POST_SUCCESS,
      payload: data,
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.SAVE_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const unsavePostAction = (id) => async (dispatch) => {
  try {
    const { error, data } = await api.unsavePost(id);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.UNSAVE_POST_SUCCESS,
      payload: data,
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.UNSAVE_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const getSavedPostsAction = (limit = 10, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getSavedPosts(limit, skip);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_SAVED_POSTS_SUCCESS,
      payload: {
        posts: data.posts || data,
        totalPosts: data.totalPosts || (Array.isArray(data) ? data.length : 0),
        page: skip / limit + 1,
      },
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_SAVED_POSTS_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const getPrivatePostsAction = (limit = 10, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getPrivatePosts(limit, skip);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_PRIVATE_POSTS_SUCCESS,
      payload: {
        posts: data.formattedPosts || data.posts || data,
        totalPosts: data.totalPosts || (Array.isArray(data) ? data.length : 0),
        page: skip / limit + 1,
      },
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_PRIVATE_POSTS_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const increaseSavedByCount = (postId) => async (dispatch) => {
  dispatch({
    type: types.INCREASE_SAVED_BY_COUNT,
    payload: postId,
    meta: {
      requiresAuth: true,
    },
  });
};

export const decreaseSavedByCount = (postId) => async (dispatch) => {
  dispatch({
    type: types.DECREASE_SAVED_BY_COUNT,
    payload: postId,
    meta: {
      requiresAuth: true,
    },
  });
};

export const getPublicPostsAction = (publicUserId, limit = 10, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getPublicPosts(publicUserId, limit, skip);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_PUBLIC_POSTS_SUCCESS,
      payload: {
        posts: data.posts || data,
        totalPosts: data.totalPosts || (Array.isArray(data) ? data.length : 0),
        page: skip / limit + 1,
      },
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_PUBLIC_POSTS_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const getSkillsFeedPostsAction = (limit = 10, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getSkillsFeedPosts(limit, skip);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_SKILLS_FEED_POSTS_SUCCESS,
      payload: {
        page: skip / limit + 1,
        posts: data.formattedPosts,
        totalPosts: data.totalPosts,
      },
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_SKILLS_FEED_POSTS_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const getFollowingPostsAction = (limit = 10, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getFollowingPosts(limit, skip);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_FOLLOWING_POSTS_SUCCESS,
      payload: {
        page: skip / limit + 1,
        posts: data.formattedPosts || data.posts || data,
        totalPosts: data.totalPosts || (Array.isArray(data) ? data.length : 0),
      },
      meta: {
        requiresAuth: true,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_FOLLOWING_POSTS_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
  }
};

export const clearFollowingPostsAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_FOLLOWING_POSTS,
    meta: {
      requiresAuth: true,
    },
  });
};

export const reportPostAction = (postId, reportReason) => async (dispatch) => {
  try {
    const { error, data } = await api.reportPost(postId, reportReason);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.REPORT_POST_SUCCESS,
      payload: { postId, data },
      meta: {
        requiresAuth: true,
      },
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.REPORT_POST_FAIL,
      payload: error.message,
      meta: {
        requiresAuth: true,
      },
    });
    return { success: false, error: error.message };
  }
};
